export default {
  id: "messages",
  title: "Messages & Announcements",
  section: "Daily Operations",
  order: 22,
  keywords: "messages chat direct group conversation announcements email sms broadcast attachments participants",
  body: `
## What it is

Messages is the in-app messenger for everyone on the platform — admins,
leads, caregivers, employment specialists, counselors, and clients — plus
an admin-only **Announcements** broadcaster that reaches people by email
and text.

## How messaging works

- The page is two panes: conversations on the left (most recent first), the
  open thread on the right. On phones it's one pane at a time with a Back
  button.
- Anyone active in the system can be messaged — there are no role
  restrictions on who can talk to whom.
- Messaging a person who already has a thread with you **reopens that
  thread** — you can't create duplicate direct conversations.
- Messages support **file attachments**; you can **edit your own sent
  messages** (recipients see an "edited" mark); scrolling up loads older
  history. New messages appear within seconds without refreshing.

### Step by step: starting a conversation

1. Click the **+** button above the conversation list.
2. Choose **Direct Message** and pick the person (search by name or email),
   or **Group Conversation**, give it a name, and pick the participants.
3. Type and send. Attachments go via the clip icon.

### Managing a group

Open the group's **Manage Participants**:

- Anyone can be **added**.
- Group admins can **remove** participants — except themselves and the
  group's creator.
- **Leave conversation** stops your notifications; for direct threads the
  conversation simply reopens if the other person writes again.

## How announcements work (admins only)

The collapsible panel at the top of the page sends one-way broadcasts
outside the app — useful for schedule alerts, policy notices, weather
closures.

### Step by step: sending an announcement

1. Expand **Announcements** and write the **Subject** and **Body**.
2. Choose the **Delivery Method**: Email, SMS, or Email & SMS.
3. Choose the **Target User Types** — any combination of Admin, Lead,
   Caregiver, Employment Specialist, Counselor, Client.
4. Send. Delivery runs in the background ("being sent to N recipients") —
   you can leave the page.
5. The **Recent Announcements** table below shows the last ten with
   recipient counts, types, method, and date.

**Important**: announcements are outbound only. Replies to the email or
text do **not** come back into the app — if you expect responses, say how
to respond in the body (call the office, message in the app, etc.).
`,
};
